<template>
<div>
    <v-select
        :label="label"
        :items="select_choices"
        :value="value"
        v-on:change="onChange"
    />

    <div
        style="padding-left: 15px; padding-right: 15px;"
    >
        <b>{{label}} Text: </b> {{agreement_text}}
    </div>
</div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: function() { return null; }
        },

        value: {
            type: String,
            default: function() { return null; }
        },

        choices: {
            type: Array,
            default: function() { return []; }
        },

        allow_none: {
            type: Boolean,
            default: function() { return false; }
        }
    },

    methods: {
        onChange(value) {
            this.$emit('input',value);
        }
    },

    computed: {
        select_choices() 
        {
            let ret = [];

            if ( this.allow_none )
            {
                ret.push({'text': 'None', 'value': null});
            }

            for ( let i = 0; i < this.choices.length; i++ )
            {
                if ( this.choices[i].is_archived && this.choices[i].agreement_id != this.value )
                    continue;

                ret.push({
                    'text' : this.choices[i].label,
                    'value' : this.choices[i].agreement_id,
                 });
            }

            return ret;
        },

        agreement_text()
        {
            for ( let i = 0; i < this.choices.length; i++ )
            {
                if ( this.choices[i].agreement_id == this.value )
                    return this.choices[i].agreement_text;
            }

            return "None";
        },
    },
}
</script>

<style lang="scss" scoped>

</style>